export const API_URL = getAPIURL();

function getAPIURL(){
    let url;
    switch(window.location.host) {
      case 'adminblog.daksho.com':
        url = 'https://apiblog.daksho.com';
        break;
      case 'adminblog.studytiming.com':
        url = 'https://apiblog.studytiming.com';
        break;
      default:
        url = 'http://localhost:8090';
        //url = 'https://apiblog.studytiming.com';
        //url = 'https://apiblog.daksho.com';
    }
    return url;
}